__turbopack_context__.v({
  "header": "Header-module__ldgnoG__header",
  "logo": "Header-module__ldgnoG__logo",
  "nav": "Header-module__ldgnoG__nav",
  "nav-link": "Header-module__ldgnoG__nav-link",
  "nav-links": "Header-module__ldgnoG__nav-links",
});
